import { render, staticRenderFns } from "./VideoCallContainer.vue?vue&type=template&id=6cdd7b22&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./VideoCallContainer.vue?vue&type=script&lang=js&"
export * from "./VideoCallContainer.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallContainer.vue?vue&type=style&index=0&id=6cdd7b22&lang=scss&scoped=true&"
import style1 from "./VideoCallContainer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd7b22",
  null
  
)

export default component.exports